import React from 'react';

export function ChartTooltip({ state }) {
    if (!state?.visible) return null;
    return (
        <div className="chart-tooltip" style={{ left: state.x, top: state.y }}>
            {state.title && (
                <div className={`chart-tooltip__title${state.lines.length ? '' : ' chart-tooltip__title--no-lines'}`}>
                    {state.title}
                </div>
            )}
            {state.lines.map((line, i) => (
                <div key={i} className="chart-tooltip__line">
                    {line}
                </div>
            ))}
            <div className="chart-tooltip__arrow" />
        </div>
    );
}

/**
 * @param {Function} setState  — React setState for tooltip state
 * @param {Function} [format]  — optional (item) => { title, lines } formatter.
 *                               If omitted, uses Chart.js default title/body.
 */
export function createExternalTooltip(setState, format) {
    return ({ chart, tooltip }) => {
        if (tooltip.opacity === 0) {
            setState({ visible: false });
            return;
        }

        let title, lines;
        if (format) {
            const item = tooltip.dataPoints?.[0];
            if (!item) return;
            ({ title, lines } = format(item));
        } else {
            title = tooltip.title?.[0] ?? null;
            lines = tooltip.body?.flatMap(b => b.lines) ?? [];
        }

        setState({
            visible: true,
            x: chart.canvas.offsetLeft + tooltip.caretX,
            y: chart.canvas.offsetTop  + tooltip.caretY,
            title,
            lines,
        });
    };
}
